
















import { Component, Prop, Vue, Ref } from 'vue-property-decorator'

@Component
export default class ResetPassword extends Vue {
  @Prop(String)
  private email!: string

  @Prop(String)
  private token!: string
}
